import React, { useEffect, useState } from 'react';
import { Modal } from 'react-responsive-modal';
import 'react-responsive-modal/styles.css';
import { useRecoilState, useRecoilValue } from 'recoil';
import styled from 'styled-components';
import '../../styles/CustomModal.css';
import { HotelIntroType } from '../../controller/StoreController';
import { SelectType } from '../DropdownSelect';

const CardContentModal = (oProps: {
  isVisible: boolean;
  setVisible: any;
  hotelInfo: HotelIntroType;
  currentStore: SelectType;
}) => {
  const [lang, setLang] = useState<number>(0);

  const onCloseModal = () => {
    oProps.setVisible(false);
  };

  const getLangToTitle = () => {
    if (lang === 1) return oProps.hotelInfo.title_en === null ? '' : oProps.hotelInfo.title_en;
    else if (lang === 2) return oProps.hotelInfo.title_ch === null ? '' : oProps.hotelInfo.title_ch;
    else if (lang === 3) return oProps.hotelInfo.title_ja === null ? '' : oProps.hotelInfo.title_ja;
    else if (lang === 4) return oProps.hotelInfo.title_th === null ? '' : oProps.hotelInfo.title_th;
    else if (lang === 5) return oProps.hotelInfo.title_es === null ? '' : oProps.hotelInfo.title_es;
    else if (lang === 6) return oProps.hotelInfo.title_fr === null ? '' : oProps.hotelInfo.title_fr;
    else if (lang === 7) return oProps.hotelInfo.title_ru === null ? '' : oProps.hotelInfo.title_ru;
    else if (lang === 8) return oProps.hotelInfo.title_de === null ? '' : oProps.hotelInfo.title_de;
    else return oProps.hotelInfo.title === null ? '' : oProps.hotelInfo.title;
  };

  const getLangToContent = (index: number) => {
    if (oProps.hotelInfo.card_content.length > index) {
      if (lang === 1)
        return oProps.hotelInfo.card_content[index].content_en === null
          ? ''
          : oProps.hotelInfo.card_content[index].content_en;
      else if (lang === 2)
        return oProps.hotelInfo.card_content[index].content_ch === null
          ? ''
          : oProps.hotelInfo.card_content[index].content_ch;
      else if (lang === 3)
        return oProps.hotelInfo.card_content[index].content_ja === null
          ? ''
          : oProps.hotelInfo.card_content[index].content_ja;
      else if (lang === 4)
        return oProps.hotelInfo.card_content[index].content_th === null
          ? ''
          : oProps.hotelInfo.card_content[index].content_th;
      else if (lang === 5)
        return oProps.hotelInfo.card_content[index].content_es === null
          ? ''
          : oProps.hotelInfo.card_content[index].content_es;
      else if (lang === 6)
        return oProps.hotelInfo.card_content[index].content_fr === null
          ? ''
          : oProps.hotelInfo.card_content[index].content_fr;
      else if (lang === 7)
        return oProps.hotelInfo.card_content[index].content_ru === null
          ? ''
          : oProps.hotelInfo.card_content[index].content_ru;
      else if (lang === 8)
        return oProps.hotelInfo.card_content[index].content_de === null
          ? ''
          : oProps.hotelInfo.card_content[index].content_de;
      else
        return oProps.hotelInfo.card_content[index].content === null
          ? ''
          : oProps.hotelInfo.card_content[index].content;
    }
  };

  return (
    <Modal
      open={oProps.isVisible}
      onClose={onCloseModal}
      center
      classNames={{
        modal: 'cardContentModal',
        overlay: 'cardContentModalOverlay',
      }}
      showCloseIcon={true}
      animationDuration={150}
      closeIcon={<img src={`${process.env.PUBLIC_URL}/svg/ic_close_white.svg`} alt="ic" />}>
      <Style>
        <div className="modal">
          <div className="header">
            <h2>{oProps.currentStore.name}</h2>
            <h1>{getLangToTitle()}</h1>
            <div className="bar" />
          </div>
          <img
            className="closeIcon"
            src={`${process.env.PUBLIC_URL}/svg/ic_arrow_left_white.svg`}
            alt="ic"
            onClick={onCloseModal}
          />
          <div className="modalContentWrap">
            {oProps.hotelInfo.card_content.map((item, idx: number) => (
              <div className="contentWrap" key={idx}>
                {item.content_type === 0 && item.url !== null ? (
                  <img src={item.url} alt="호텔소개 이미지" />
                ) : (
                  <p>{getLangToContent(idx)}</p>
                )}
              </div>
            ))}
          </div>
        </div>
      </Style>
    </Modal>
  );
};

export default CardContentModal;

const Style = styled.div`
  .modal {
    display: flex;
    align-items: center;
    justify-content: start;
    flex-direction: column;
    height: 90vh;
    text-align: center;
  }
  .header {
    padding: 40px 0;
    text-align: center;
    top: 0;

    h2 {
      font-size: 28px;
      line-height: 40px;
      font-weight: 300;
      color: #ffffff;
    }
    h1 {
      font-size: 36px;
      line-height: 50px;
      font-weight: 600;
      color: #ffffff;
    }
    .bar {
      margin: 0 auto;
      margin-top: 40px;
      width: 50px;
      height: 4px;
      background: #4dd2ae;
    }
  }
  .closeIcon {
    position: absolute;
    left: 2%;
    top: 1.5%;
  }
  /* modalContentWrap */
  .modalContentWrap {
    width: 100%;
    height: 100%;
    overflow-y: auto !important;
    margin-bottom: 40px;

    img {
      width: 100%;
      margin-bottom: 12px;
      object-fit: contain;

      padding: 0 20px;
    }
  }

  p {
    margin-bottom: 12px;
    padding: 0 20px;
    font-size: 18px;
    font-weight: 300;
    line-height: 28px;
    text-align: left;
    white-space: pre-line;
    color: #ffffff;
  }
`;
